import { post } from '../utils/httpInterceptor';

const normalizeApiBase = (baseUrl) => {
  const trimmed = (baseUrl || '').trim();
  if (!trimmed) {
    return 'http://localhost:8085/api/v1';
  }
  return trimmed.endsWith('/') ? trimmed.slice(0, -1) : trimmed;
};

const apiUrl = normalizeApiBase(process.env.REACT_APP_LOAD_PAGE_URL);

class LoginService {

  static async login(username, password) {
    try {
      const response = await fetch(`${apiUrl}/login`, {
        method: 'POST',
        cache: 'no-store',
        headers: {
          'Content-Type': 'application/json',
          'Cache-Control': 'no-store',
          'Pragma': 'no-cache',
          'Expires': '0',
        },
        body: JSON.stringify({ username, password }),
      });

      let rawBody = '';
      let data = null;
      try {
        rawBody = await response.text();
        data = rawBody ? JSON.parse(rawBody) : {};
      } catch (jsonError) {
        data = { raw: rawBody };
      }

      this.handleUnauthorized(response, data, rawBody);

      // Guardar token y datos del usuario de forma centralizada
      if (data?.token) {
        localStorage.removeItem('profileImage');
        localStorage.removeItem('selectedCompanyId');
        localStorage.setItem('authToken', data.token);

        const userData = {
          name: data.name || '',
          username: data.username || '',
          email: data.email || '',
          personFullName: data.personFullName || '',
          personDocument: data.personDocument || '',
          personPhone: data.personPhone || ''
        };
        
        localStorage.setItem('userData', JSON.stringify(userData));
        localStorage.setItem('displayName', userData.name);
        localStorage.setItem('username', userData.username);
      }

      return data || {};
    } catch (error) {
      throw error;
    }
  }

  static async changePassword({ password }) {
    try {
      const data = await post('/login/new-password', { password });
      return data;
    } catch (error) {
      // Si es error de autenticación, el interceptor ya manejó el logout
      throw error;
    }
  }

  static handleUnauthorized(response, data, rawBody) {
    if (!response.ok) {
      const messageFromBackend = data?.message || data?.error || rawBody;
      const error = new Error(messageFromBackend || `HTTP error! Status: ${response.status}`);
      error.response = {
        status: response.status,
        data,
        raw: rawBody
      };
      throw error;
    }
  }

  static async logout() {
    try {
      await post('/login/logout', {});
    } catch (error) {
      // El cierre local debe ejecutarse aunque falle el backend
    }
    localStorage.removeItem('authToken');
    localStorage.removeItem('userData');
    localStorage.removeItem('displayName');
    localStorage.removeItem('profileImage');
    localStorage.removeItem('selectedCompanyId');
    window.location.href = '/';
  }
}

export default LoginService;
